import { render, staticRenderFns } from "./LearnIcon.vue?vue&type=template&id=cc94d67c"
import script from "./LearnIcon.vue?vue&type=script&lang=js"
export * from "./LearnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports